// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__22Jv4","modalFooterButton":"ModalNotes_modalFooterButton__1twO6"};